/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ParamVm,
    ParamVmFromJSON,
    ParamVmFromJSONTyped,
    ParamVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface FeatureSwitchVm
 */
export interface FeatureSwitchVm {
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSwitchVm
     */
    maintainedDevices?: boolean;
    /**
     * 
     * @type {ParamVm}
     * @memberof FeatureSwitchVm
     */
    failureListParam1?: ParamVm;
    /**
     * 
     * @type {ParamVm}
     * @memberof FeatureSwitchVm
     */
    failureListParam2?: ParamVm;
    /**
     * 
     * @type {ParamVm}
     * @memberof FeatureSwitchVm
     */
    failureDescription1?: ParamVm;
    /**
     * 
     * @type {ParamVm}
     * @memberof FeatureSwitchVm
     */
    failureDescription2?: ParamVm;
    /**
     * 
     * @type {ParamVm}
     * @memberof FeatureSwitchVm
     */
    failureSpecialCase?: ParamVm;
    /**
     * 
     * @type {ParamVm}
     * @memberof FeatureSwitchVm
     */
    failureCommentExtra?: ParamVm;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSwitchVm
     */
    exam?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSwitchVm
     */
    contractorAcceptOfTaskAssignment?: boolean;
}

export function FeatureSwitchVmFromJSON(json: any): FeatureSwitchVm {
    return FeatureSwitchVmFromJSONTyped(json, false);
}

export function FeatureSwitchVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureSwitchVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maintainedDevices': !exists(json, 'maintainedDevices') ? undefined : json['maintainedDevices'],
        'failureListParam1': !exists(json, 'failureListParam1') ? undefined : ParamVmFromJSON(json['failureListParam1']),
        'failureListParam2': !exists(json, 'failureListParam2') ? undefined : ParamVmFromJSON(json['failureListParam2']),
        'failureDescription1': !exists(json, 'failureDescription1') ? undefined : ParamVmFromJSON(json['failureDescription1']),
        'failureDescription2': !exists(json, 'failureDescription2') ? undefined : ParamVmFromJSON(json['failureDescription2']),
        'failureSpecialCase': !exists(json, 'failureSpecialCase') ? undefined : ParamVmFromJSON(json['failureSpecialCase']),
        'failureCommentExtra': !exists(json, 'failureCommentExtra') ? undefined : ParamVmFromJSON(json['failureCommentExtra']),
        'exam': !exists(json, 'exam') ? undefined : json['exam'],
        'contractorAcceptOfTaskAssignment': !exists(json, 'contractorAcceptOfTaskAssignment') ? undefined : json['contractorAcceptOfTaskAssignment'],
    };
}

export function FeatureSwitchVmToJSON(value?: FeatureSwitchVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maintainedDevices': value.maintainedDevices,
        'failureListParam1': ParamVmToJSON(value.failureListParam1),
        'failureListParam2': ParamVmToJSON(value.failureListParam2),
        'failureDescription1': ParamVmToJSON(value.failureDescription1),
        'failureDescription2': ParamVmToJSON(value.failureDescription2),
        'failureSpecialCase': ParamVmToJSON(value.failureSpecialCase),
        'failureCommentExtra': ParamVmToJSON(value.failureCommentExtra),
        'exam': value.exam,
        'contractorAcceptOfTaskAssignment': value.contractorAcceptOfTaskAssignment,
    };
}


